// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GgyD","top":"styles_top__j8I4b","left":"styles_left__2mwby","description":"styles_description__1bFIY"};